import React from 'react'
import EmailEditor from '../helpers/email-editor/EmailEditor'

function EmailContentStep({ emailTemplate, setEmailTemplate, subjectLine }) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-bold text-gray-900 mb-2">Email Content</h3>
            <p className="text-muted mb-8">Create the main content of your email using the editor.</p>
            
            <div className="mb-6">
                <EmailEditor 
                    loadjson={emailTemplate}
                    emailSubject={subjectLine || 'Email Template'}
                />
            </div>
        </div>
    )
}

export default EmailContentStep
